export default __webpack_public_path__ + "static/media/onboarding3.8fb0a787.png";